/** Application workflow only: independent payment/registration/decision statuses are excluded. */
export const activeApplicationStatuses = ['DRAFT', 'SUBMITTED', 'APPROVED', 'REJECTED', 'DEFERRED', 'WITHDRAWN', 'TUITION_PAYMENT_STAGE', 'PAID', 'VISA_APPLICATION', 'VISA_APPROVED', 'ENROLLED'] as const;
export function normalizeApplicationStatus(status: string): string {
  return status === 'PENDING' || status === 'UNDER_REVIEW' ? 'SUBMITTED' : status;
}
export function applicationStatusLabel(status: string, historical = false): string {
  if (historical && (status === 'PENDING' || status === 'UNDER_REVIEW')) {
    return `${status === 'PENDING' ? 'Pending' : 'Under Review'} (legacy)`;
  }
  const current = historical ? status : normalizeApplicationStatus(status);
  if (current === 'TUITION_PAYMENT_STAGE') return 'Tuition Payment';
  return current.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
}
